import { SUPERREADER_SCOPE } from '../constants';

export function formatTimestamp(iso?: string): string {
  if (!iso) return '';
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? iso : date.toLocaleString();
}

export function scopeLabel(scope: string): string {
  return scope === SUPERREADER_SCOPE ? 'All' : scope;
}

export function orderScopes(scopes: string[]): string[] {
  return [...scopes].sort((a, b) => {
    if (a === SUPERREADER_SCOPE) return -1;
    if (b === SUPERREADER_SCOPE) return 1;
    return a.localeCompare(b);
  });
}
